import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../../../InputField';
import FormError from '../../../FormError';
import SelectField from 'components/SelectField';
import states from 'helpers/states';

import styles from './styles.module.scss';
import { hasComma } from 'helpers/validators';

let EditShippingForm = ({ handleSubmit, error }) => (
  <div>
    <form onSubmit={handleSubmit}>
      <div className={styles.row}>
        <div className={styles.leftHalf}>
          <Field component={InputField} name="full_name" label="Full Name" />
        </div>
        <div className={styles.rightHalf}>
          <Field component={InputField} name="address1" label="Address1" />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.leftHalf}>
          <Field component={InputField} name="address2" label="Address2" />
        </div>
        <div className={styles.rightHalf}>
          <Field component={InputField} name="city" label="City" />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.leftHalf}>
          <Field
            component={SelectField}
            name="state"
            label="State"
            options={states.map((state) => [state.abbreviation, state.name])}
            placeholder="Select state"
          />
        </div>
        <div className={styles.rightHalf}>
          <Field component={InputField} name="zip_code" label="Zip Code" />
        </div>
      </div>

      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary">Save Shipping</button>
    </form>
  </div>
);

const validate = (values) => {
  const requiredFields = ['full_name', 'address1', 'city', 'state', 'zip_code'];
  let errors = {};

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });

  if (values.full_name && hasComma(values.full_name)) {
    errors.full_name = 'Comma sign is not allowed';
  }

  return errors;
};

EditShippingForm = reduxForm({
  form: 'editShipping',
  validate,
})(EditShippingForm);

export default EditShippingForm;
